import { post, get } from '@user/store/services/crud'
import {
  IOpportunityIsCloseableResponse,
  IOpportunityIsCloseableModel,
} from '@user/store/opportunity/typings'
import { ServiceConfig } from '@user/store/services/config'
import { useEffect, useState } from 'react'

export const useGetOpportunityIsCloseableModel = () => {
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [opportunity, setOpportunity] = useState<
    IOpportunityIsCloseableModel | undefined
  >()
  const [isCloseableDetails, setIsCloseableDetails] =
    useState<IOpportunityIsCloseableResponse>()

  const baseUrl: string = `${ServiceConfig.baseAPIUrl}/Opportunity`

  async function createNewOpportunityCloseable(
    opportunity: IOpportunityIsCloseableModel,
  ) {
    if (!opportunity || !opportunity?.opportunityId) return
    try {
      setStatus('pending')
      const response = await get(
        `${baseUrl}/IsCloseable?id=${opportunity.opportunityId}`,
      )
      if (response.ok) {
        setStatus('success')
        const details: IOpportunityIsCloseableResponse = await response.json()
        if (details) {
          setIsCloseableDetails(details)
        }
      } else {
        setStatus('fail')
      }
    } catch (error) {
      console.error(error)
    } finally {
      setOpportunity(undefined)
      setStatus('idle')
    }
  }

  async function convertLeadToOpportunityClosable() {
    try {
      setStatus('pending')
      const response = await post(`${baseUrl}/IsCloseable`, opportunity)
      if (response.ok) {
        setStatus('success')
        const details: IOpportunityIsCloseableResponse = await response.json()
        setIsCloseableDetails(details)
      } else {
        setStatus('fail')
      }
    } catch (error) {
      console.error(error)
    } finally {
      setOpportunity(undefined)
      setStatus('idle')
    }
  }

  useEffect(() => {
    const execute = async () => {
      if (opportunity) {
        if (opportunity?.opportunityId) {
          createNewOpportunityCloseable(opportunity)
          return
        }
        convertLeadToOpportunityClosable()
      }
    }
    execute()
  }, [opportunity])

  return { setOpportunity, isCloseableDetails, status }
}
